import HyperEntity from "@shared/backend/hyper-entity.decorator";
import { Fields, Relations } from "remult";
import { extender } from "../../backend/class-extender";
import { NotificationBase } from "../notification-base";
import { User } from "../user/entity";
import { UserNotificationEntityConfig } from "./config";
import { UserNotificationFilters } from "./filters";
import { UserNotificationMethods } from "./methods";

@HyperEntity("user-notification", UserNotificationEntityConfig)
export class UserNotification extends extender(
  UserNotificationFilters,
  UserNotificationMethods,
  NotificationBase,
) {
  @Fields.string({
    dbName: "to_id",
  })
  toId = "";

  @Relations.toOne<UserNotification, User>(() => User, "toId")
  to?: User;
}
